<template>
    <div class="rate-card-container col-12">
        <div :class="['row rate-card', { 'rep-example': ratesItem?.lender_rapr }]">
            <div class="order-1 d-flex flex-column col-12 col-md-3 col-lg-2 justify-content-center align-items-center">
                <div class="lender-logo-wrapper">
                    <img :src="ratesItem.lender_logo" :alt="ratesItem.lender_name + ' lender-logo'" />
                </div>

                <a v-if="hideCta" class="lender-disclosure-link flex-direction-column" @click="showOfferDetails">
                    {{ $t('ratesTable.lenderTsAndInfo') }}
                </a>
            </div>

            <div class="info-wrapper--amount col-12 col-md order-2 order-md-4 order-lg-2">
                <RatesCardAmount
                    :loanRange="this.ratesItem.loan_range"
                    :rangeLabel="$t('ratesTable.loanAmount.label')"
                />
            </div>

            <div class="table-value col-6 col-lg info-wrapper--term order-3 order-md-2 order-lg-3 d-md-none d-lg-flex">
                <RatesCardRangeGeneric
                    :rangeMin="ratesItem?.term_range?.min"
                    :rangeMax="ratesItem?.term_range?.max"
                    rangeMeasurement="months"
                    :rangeLabel="$t('ratesTable.loanTerm.label')"
                />
            </div>

            <div class="table-value col-6 col-lg info-wrapper--apr order-4 order-md-3 order-lg-4 d-md-none d-lg-flex">
                <RatesCardSingleValue
                    :columnValue="ratesItem?.rep_apr"
                    appendingValueSymbol="%"
                    :valueLabel="$t('ratesTableWidget.repApr.label')"
                />
            </div>

            <div class="order-2 col-md-3 info-wrapper--amount d-none d-md-block d-lg-none">
                <div class="table-value col info-wrapper--term order-3 order-md-2 w-100">
                    <RatesCardRangeGeneric
                        :rangeMin="ratesItem?.term_range?.min"
                        :rangeMax="ratesItem?.term_range?.max"
                        rangeMeasurement="months"
                        :rangeLabel="$t('ratesTable.loanTerm.label')"
                    />
                </div>

                <div class="table-value col info-wrapper--apr order-4 order-md-3 w-100">
                    <RatesCardSingleValue
                        :columnValue="ratesItem?.rep_apr"
                        appendingValueSymbol="%"
                        :valueLabel="$t('ratesTableWidget.repApr.label')"
                    />
                </div>
            </div>

            <div v-if="!hideCta" class="lender-button-wrapper col order-5">
                
                <a class="button secondary rates-table-button"  @click="ratesTableRedirect">
                    {{ $t('form.general.continue') }}
                </a>

                <a class="lender-disclosure-link" @click="showOfferDetails">
                    {{ $t('ratesTable.lenderTsAndInfo') }}
                </a>
            </div>

            <div v-if="ratesItem?.lender_rapr && !hideRepApr" class="representative-example col-12 order-6">
                <p>{{ $t('results.repExample') }}: <span v-html="ratesItem?.lender_rapr"></span></p>
            </div>
        </div>

        <FullScreenModal :name="modalName" :forceNoOverlay="true">
            <template v-slot:topHeading>
                <h2 class="offer-details-modal-title">
                    {{ $t('ratesTable.offerDetails') }}
                </h2>
            </template>

            <template v-slot>
                <h3 class="mt-3 offer-details-subheading">{{ ratesItem.lender_name }}</h3>
                <p>{{ ratesItem.about_lender }}</p>

                <h4 class="offer-details-subheading">{{ $t('ratesTable.TermsAndConditions') }}</h4>
                <p>{{ ratesItem.terms }}</p>
            </template>
        </FullScreenModal>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { url } from '@js/utilities/url.js'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    props: {
        ratesItem: {},
        uid: null,
        hideRepApr: false,
    },
    inject: ['isDynamicRatesTables'],
    data() {
        return {
            loading: false,
            errors: [],
        }
    },

    computed: {
        modalName() {
            return this.ratesItem.lender_name + this.uid
        },
        hideCta: function () {
            return this.store?.state?.global?.page?.hide_cta
        },
    },

    methods: {
        showOfferDetails: function () {
            this.emitter.emit(this.modalName, {
                open: true,
            })
        },

        ratesTableRedirect: function () {
            if(this.isDynamicRatesTables) {
                this.trackEvent('event', {
                    eventCategory: 'button',
                    eventAction: 'click',
                    eventLabel: 'check-my-rate',
                    eventValue: this.ratesItem.lender_name,
                })

                const location = this.$router.resolve({
                    name: 'apply',
                })

               return window.location = url(location.href)
            }

            return window.open(this.ratesItem.redirect_url, '_blank');
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';
</style>
